import { render, staticRenderFns } from "./PassoEditarRegistro.vue?vue&type=template&id=29c0978c&"
import script from "./PassoEditarRegistro.vue?vue&type=script&lang=js&"
export * from "./PassoEditarRegistro.vue?vue&type=script&lang=js&"
import style0 from "./PassoEditarRegistro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports